import {
    Button,
    Checkbox,
    Collapse,
    FormControl,
    FormControlLabel,
    Grid,
    IconButton,
    InputLabel,
    Menu,
    MenuItem,
    Paper,
    Select,
    Typography,
    List,
    ListItemButton,
    ListItemText,
    Box,
    Tooltip,
} from '@mui/material';
import React from 'react';
import { useSensorListData } from '../../data/DataProviders/SensorListDataProvider';
import { isDataLoaded } from '../../types';
import { PDIGraphDataProvider } from '../../data/DataProviders/PDIGraphDataProvider';
import { PDIGraph } from '../PdiGraph/PdiGraph';
import { MaxQmaxGraphProvider } from '../../data/DataProviders/QmaxGraphDataProvider';
import { QmaxGraph } from '../QmaxGraph/QmaxGraph';
import { PPCGraphDataProvider } from '../../data/DataProviders/PPCGraphDataProvider';
import { PPCGraph } from '../PpcGraph/PPCGraph';
import { DataIndicators } from '../DataIndicators';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import * as PXBColors from '@brightlayer-ui/colors';
import { InfoListItem } from '@brightlayer-ui/react-components';
import { Done, ExpandLess, ExpandMore } from '@mui/icons-material';
import SensorsSharpIcon from '@mui/icons-material/SensorsSharp';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { ChartColors, ChartColorsHover } from '../ReusableTrendsGraph/colors';
import { SensorDetailData } from '../SensorTrend/SensorDetails';
import makeStyles from '@mui/styles/makeStyles';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { Icon } from '../../lib/icons';
import { Thunks } from '../../actions';
import { Selectors } from '../../selectors';
import { useDispatch, useSelector } from 'react-redux';
import { useAuthHelper } from '../AuthContextProvider';
import { useToasts } from '../../data/DataProviders/ToastProvider';
const sensorStyles = makeStyles(() => ({
    formControlLabel: { fontSize: '14px', '& label': { fontSize: '0.6rem' } },
    formControl: {
        margin: '6px 4px 4px 20px',
    },
    listTitle: {
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '19px',
        color: '#007BC1',
    },
    listItems: {
        fontSize: '14px',
        lineHeight: '14px',
        height: '48px',
        flex: 0,
        padding: '6px 10px',
        width: '202px',
    },
    selectView: {
        marginRight: '0px',
        float: 'left',
        padding: '20px 20px',
        color: '#007BC1',
        fontSize: '14px',
        lineHeight: '14px',
        fontWeight: 600,
        paddingBottom: '0px',
    },
    exportBtn: {
        float: 'right',
        backgroundColor: PXBColors.blue[500],
        marginTop: '9px',
        cursor: 'pointer',
        color: '#fff',
        opacity: '1',
        padding: '7px',
        minWidth: '150px',
    },
}));
export const SensorOverView: React.FC<{ deviceId: string }> = (props) => {

   
    const dispatch = useDispatch();
    const { addToast } = useToasts();
    const AuthHelper = useAuthHelper();
    const getResponseData = useSensorListData();
    const useStyles = sensorStyles();
    const { t } = useLanguageLocale();
    const isEmpty = isDataLoaded(getResponseData) ? getResponseData.value.channelData.length === 0 : false;
    const currentAppRoute = useCurrentAppRoute();
    const alarmChannelNumber: any =
        currentAppRoute.type === 'TimelineSiteTabDetails' ||
        currentAppRoute.type === 'TimelineLocationTabDetails' ||
        currentAppRoute.type === 'TimelineOrganizationTabDetails'
            ? currentAppRoute.phaseDate
            : 1;
    const convertNumber = parseInt(alarmChannelNumber);  

    const [isActiveChannelNumber, setActiveChannelNumber] = React.useState<number[]>([convertNumber]);
    const [timeRange, setTimeRange] = React.useState(0);
    const getSensorDetailTableData = useSelector(Selectors.SensorDetailSelectors.sensorDetailRowData);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    React.useEffect(() => {       
        setActiveChannelNumber([convertNumber]);
        dispatch(Thunks.SensorDetailThunks.sensorChannelDetailForm(props.deviceId, [convertNumber], AuthHelper, addToast));
    }, []);
    const dataItem: any = [];
    const selectAllChannelValue: any = [];
    if (isDataLoaded(getResponseData)) {
        const channelDataResult = getResponseData.value.channelData;
        channelDataResult.map((id) => {
            if (id.isActive === true) {
                dataItem.push({ channelNumber: id.channelNumber, channelName: id.channelName, isFlag: id.isActive });
                selectAllChannelValue.push(id.channelNumber);
            }
            return true;
        });
    }

    const handleChange = (event: any): void => {
        setTimeRange(event.target.value);
    };

    const newEDate: any = new Date();
    const add = 1;
    const month: number = newEDate.getMonth();
    let endMonth: any = `${month + add}`;
    let endDay: any = `${newEDate.getDate()}`;
    const endYear: any = newEDate.getFullYear();
    if (endMonth.length < 2) endMonth = `0${endMonth}`;
    if (endDay.length < 2) endDay = `0${endDay}`;
    const newEndDate: any = [endYear, endMonth, endDay].join('-');

    let newStartDate: any;
    const pickUpStartDate: any = new Date();
    if (timeRange === 0) {
        const newDate: any = pickUpStartDate.setDate(pickUpStartDate.getDate() - 90);
        const dT: any = new Date(newDate);
        const newAdd = 1;
        const newMonth: number = dT.getMonth();
        let newMonths: any = `${newMonth + newAdd}`;
        let newDays: any = `${dT.getDate()}`;
        const newYears: any = dT.getFullYear();
        if (newMonths.length < 2) newMonths = `0${newMonths}`;
        if (newDays.length < 2) newDays = `0${newDays}`;
        newStartDate = [newYears, newMonths, newDays].join('-');
    } else {
        const newDate: any = pickUpStartDate.setDate(pickUpStartDate.getDate() - 365);
        const d: any = new Date(newDate);
        const newAdds = 1;
        const newMonths: number = d.getMonth();
        let months: any = `${newMonths + newAdds}`;
        let days: any = `${d.getDate()}`;
        const years: any = d.getFullYear();
        if (months.length < 2) months = `0${months}`;
        if (days.length < 2) days = `0${days}`;
        newStartDate = [years, months, days].join('-');
    }

    const opens = Boolean(anchorEl);
    const handleClicks = (event: React.MouseEvent<HTMLElement>): void => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (): void => {
        setAnchorEl(null);
    };

    const filterByIsolateNoise = (): void => {
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    };

    const [open, setOpen] = React.useState(true);
    const handleClick = (): void => {
        setOpen(!open);
    };

    const channelListAction = (channelNumbers: number): void => {
        const selectedChannel = [...isActiveChannelNumber];
        const channelIndex = selectedChannel.indexOf(channelNumbers);
        if (channelIndex >= 0) {
            selectedChannel.splice(channelIndex, 1);
        } else {
            selectedChannel.push(channelNumbers);
        }
        setActiveChannelNumber(selectedChannel);

        dispatch(
            Thunks.SensorDetailThunks.sensorChannelDetailForm(props.deviceId, selectedChannel, AuthHelper, addToast)
        );
    };

    const ITEM_HEIGHT = 48;
    const convertHex = (hex: string, opacity: number): string => {
        const newhex = hex.replace('#', '');
        const r = parseInt(newhex.substring(0, 2), 16);
        const g = parseInt(newhex.substring(2, 4), 16);
        const b = parseInt(newhex.substring(4, 6), 16);

        return `rgba(${r},${g},${b},${opacity})`;
    };

    const selectAll = (): void => {
        const selectChannelAll = true;
        setActiveChannelNumber(selectAllChannelValue);
        const selectedAllChannelValue: any = [];
        selectAllChannelValue.map((element: any) => {
            const obj = {
                channelNumber: element,
            };
            selectedAllChannelValue.push(obj);
        });
        
        dispatch(
            Thunks.SensorDetailThunks.sensorChannelDetailForm(
                props.deviceId,
                selectedAllChannelValue,
                AuthHelper,
                addToast,
                selectChannelAll
            )
        );

        setAnchorEl(null);
    };

    const deselectAll = (): void => {
        setActiveChannelNumber([1]);
        dispatch(Thunks.SensorDetailThunks.sensorChannelDetailForm(props.deviceId, [1], AuthHelper, addToast));

        setAnchorEl(null);
    };

    return (
        <>
            <DataIndicators
                errorMessage="Record not found"
                emptyMessage="Record not found"
                data={getResponseData}
                emptyIcon="BarChart"
                isEmpty={isEmpty}
                isDetailedInfo={false}
            />
            {isDataLoaded(getResponseData) && getResponseData.value.channelData.length > 0 && (
                <Box>
                    <Grid container style={{ marginTop: 0 }}>
                        <Grid item xs={2}>
                            <FormControl
                                sx={{ m: '8px 0px 0px 0px', minWidth: 270 }}
                                style={{ width: '100%' }}
                                size="small"
                            >
                                <InputLabel id="dropdown-sensor-label"> Time Range</InputLabel>
                                <Select
                                    data-testid="time-range-value"
                                    value={timeRange}
                                    label="Channel List"
                                    onChange={handleChange}
                                    labelId="dropdown-sensor-label"
                                    id="dropdown-sensor"
                                    style={{ fontSize: '14px' }}
                                >
                                    <MenuItem value={0}>3 Month PD Graph</MenuItem>
                                    <MenuItem value={1}>12 Month Trend</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6}>
                            <span style={{ color: '#007bc1', marginLeft: '100px', fontSize: '14px' }}>Filter By:</span>

                            <Tooltip arrow title="This features available in a future release ">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            disabled={true}
                                            className={useStyles.formControl}
                                            color="primary"
                                            data-testid="Isolate Noise"
                                            onChange={filterByIsolateNoise}
                                        />
                                    }
                                    label={
                                        <Typography className={useStyles.formControlLabel}>Isolate Noise</Typography>
                                    }
                                />
                            </Tooltip>
                            <Tooltip arrow title="This features available in a future release ">
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            disabled={true}
                                            className={useStyles.formControl}
                                            color="primary"
                                            data-testid="Isolate Noise"
                                            onChange={filterByIsolateNoise}
                                        />
                                    }
                                    label={
                                        <Typography className={useStyles.formControlLabel}>
                                            Remove Seasonality
                                        </Typography>
                                    }
                                />
                            </Tooltip>
                        </Grid>
                        <Grid item xs={4}>
                       
                            <Button
                               variant="contained" disabled
                                startIcon={<Icon.GetApp />}
                                style={{
                                    float: 'right',
                                    backgroundColor: PXBColors.blue[50],
                                    marginTop: '9px',
                                    cursor: 'pointer',
                                    color: '#fff',
                                    opacity: '1',
                                    padding: '7px',
                                }}
                            >
                                {t('INSULGARD.EXPORTDATA')}
                            </Button>
                           
                        </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                        <Grid item xs={3} style={{ maxWidth: '100%', marginTop: '10px' }}>
                            <Paper>
                                <Typography style={{ marginTop: '0px' }}>
                                    <span className={useStyles.selectView}>{'Select Sensor'}</span>
                                    {
                                        <div>
                                            <IconButton
                                                data-testid="selectAll-channels"
                                                style={{ marginTop: '7px', left: '27%' }}
                                                aria-label="more"
                                                id="long-button"
                                                aria-controls={opens ? 'long-menu' : undefined}
                                                aria-expanded={opens ? 'true' : undefined}
                                                aria-haspopup="true"
                                                onClick={handleClicks}
                                            >
                                                <MoreVertIcon />
                                            </IconButton>
                                            <Menu
                                                id="long-menu"
                                                MenuListProps={{
                                                    'aria-labelledby': 'long-button',
                                                }}
                                                data-testid="choose-option-channels"
                                                anchorEl={anchorEl}
                                                open={opens}
                                                onClose={handleClose}
                                                PaperProps={{
                                                    style: {
                                                        maxHeight: ITEM_HEIGHT * 4.5,
                                                        width: '20ch',
                                                    },
                                                }}
                                            >
                                                <MenuItem onClick={selectAll} value={0}>
                                                    Select All (
                                                    {selectAllChannelValue !== undefined
                                                        ? selectAllChannelValue.length
                                                        : 0}
                                                    )
                                                </MenuItem>
                                                <MenuItem onClick={deselectAll} value={1}>
                                                    Deselect All ({selectAllChannelValue.length === 1 ? 0 : 1 })
                                                </MenuItem>
                                            </Menu>
                                        </div>
                                    }
                                </Typography>

                                {dataItem.map((item: any, index: any) => (
                                    <div key={index}>
                                        <InfoListItem
                                            data-testid="display-channelList"
                                            title={''}
                                            icon={
                                                isActiveChannelNumber.includes(item.channelNumber) ? (
                                                    <SensorsSharpIcon
                                                        style={{
                                                            color:
                                                                ChartColors[
                                                                    item.channelNumber === 1
                                                                        ? 0
                                                                        : item.channelNumber % ChartColors.length
                                                                ],
                                                            width: '100%',
                                                        }}
                                                    />
                                                ) : (
                                                    <SensorsSharpIcon style={{ color: '#424E54', width: '100%' }} />
                                                )
                                            }
                                            leftComponent={item.channelName}
                                            backgroundColor={
                                                isActiveChannelNumber.includes(item.channelNumber)
                                                    ? convertHex(
                                                          ChartColorsHover[
                                                              item.channelNumber === 1
                                                                  ? 0
                                                                  : item.channelNumber % ChartColorsHover.length
                                                          ],
                                                          3
                                                      )
                                                    : 'rgb(255,255,255)'
                                            }
                                            rightComponent={
                                                isActiveChannelNumber.includes(item.channelNumber) ? (
                                                    <Done
                                                        data-testid="trend-item-checkbox"
                                                        style={{
                                                            color:
                                                                ChartColors[
                                                                    item.channelNumber === 1
                                                                        ? 0
                                                                        : item.channelNumber % ChartColors.length
                                                                ],
                                                            marginRight: '18px',
                                                        }}
                                                    />
                                                ) : (
                                                    <></>
                                                )
                                            }
                                            statusColor={''}
                                            divider={'full'}
                                            onClick={(): void => {
                                                channelListAction(item.channelNumber);
                                            }}
                                            style={{ height: '48px', width: '100%' }}
                                        />
                                    </div>
                                ))}
                            </Paper>
                        </Grid>
                        <Grid item xs={9} style={{ marginTop: '2px' }}>
                            <List component="nav" aria-labelledby="nested-list-subheader">
                                <ListItemButton
                                    onClick={handleClick}
                                    style={{ color: '#007BC1', backgroundColor: '#ffff' }}
                                >
                                    <ListItemText>
                                        {<Typography className={useStyles.listTitle}> Sensor Details </Typography>}{' '}
                                    </ListItemText>
                                    {open ? <ExpandLess /> : <ExpandMore />}
                                </ListItemButton>
                                <Collapse in={open} timeout="auto" unmountOnExit>
                                    <List component="div" data-testid="sensorView" disablePadding>
                                        <SensorDetailData SensorTrendData={getSensorDetailTableData.channelData} />
                                    </List>
                                </Collapse>
                            </List>

                            <Grid item xs={12} style={{ marginBottom: '20px', marginTop: '10px' }}>
                                <PDIGraphDataProvider
                                    deviceId={props.deviceId}
                                    channelNumber={isActiveChannelNumber}
                                    startDate={newStartDate}
                                    endDate={newEndDate}
                                >
                                    <PDIGraph monthValue={timeRange} />
                                </PDIGraphDataProvider>
                            </Grid>
                            <Grid item xs={12} style={{ marginBottom: '20px' }}>
                                <MaxQmaxGraphProvider
                                    deviceId={props.deviceId}
                                    channelNumber={isActiveChannelNumber}
                                    startDate={newStartDate}
                                    endDate={newEndDate}
                                >
                                    <QmaxGraph monthValue={timeRange} />
                                </MaxQmaxGraphProvider>
                            </Grid>

                            <Grid item xs={12} style={{ marginBottom: '20px' }}>
                                <PPCGraphDataProvider
                                    deviceId={props.deviceId}
                                    channelNumber={isActiveChannelNumber}
                                    startDate={newStartDate}
                                    endDate={newEndDate}
                                >
                                    <PPCGraph monthValue={timeRange} />
                                </PPCGraphDataProvider>
                            </Grid>
                        </Grid>
                    </Grid>
                </Box>
            )}
        </>
    );
};
